import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import Facts from '../components/home/Facts';
import About from '../components/home/About';
import Feature from '../components/home/Feature';


const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Services />
      <Feature />
      <Facts />
      
    </div>
  );
};

export default Home;